import { render, staticRenderFns } from "./DoneResetPassword.vue?vue&type=template&id=7447086c&scoped=true&lang=pug"
import script from "./DoneResetPassword.vue?vue&type=script&lang=js"
export * from "./DoneResetPassword.vue?vue&type=script&lang=js"
import style0 from "./DoneResetPassword.vue?vue&type=style&index=0&id=7447086c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447086c",
  null
  
)

export default component.exports